<div *ngIf="bloodGroups$ | async as groups">
  <div class="list-group border-0" *ngFor="let group of groups">
    <div class="d-flex align-items-center">
      <div [inlineSVG]="group.image"></div>
      <div class="d-flex w-100 align-items-center gpl-12">
        <p class="p3-semibold text-secondary m-0 me-auto">
          {{ group.name | uppercase }}
        </p>
      </div>
    </div>

    <ng-container *ngIf="panels; else listView">
      <div
        gpuAccordion
        [onlyOneExpanded]="true"
        *ngIf="group.analyses as analyses"
      >
        <gpu-collapse
          *ngFor="let analysis of analyses; let first = first; let last = last"
          [ngClass]="{
            'gmt-20 gmt-md-24': first,
            'gmb-32 gmb-md-36': last
          }"
          class="card-shadow-1 hover-shadow active-transparent w-100 gmb-12 gpx-24"
          gptDataTrack="blood-about-collapse"
        >
          <gpu-collapse-header>
            <p
              class="p3-regular text-ellipsis gmb-0 me-auto"
              [innerHTML]="analysis.shortName + ' - ' + analysis.longName"
            ></p>
          </gpu-collapse-header>
          <gpu-collapse-content>
            <p
              *ngIf="analysis.description"
              class="p3-regular text-secondary gm-0 gmt-4"
              [innerHTML]="analysis.description"
            ></p>
          </gpu-collapse-content>
        </gpu-collapse>
      </div>
    </ng-container>

    <ng-template #listView>
      <ng-container *ngIf="group.analyses as analyses">
        <div
          *ngFor="let analysis of analyses; let first = first; let last = last"
          [ngClass]="{
            'gmt-8 gmt-md-12': first,
            'gmb-32 gmb-md-36': last
          }"
          class="gmb-12"
        >
          <app-analysis-link
            [analysis]="analysis"
            [type]="AnalysesTypesLowercase.Blood"
            [reCheckLabel]="true"
          ></app-analysis-link>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>

<gpu-loading-spinner-wrapper *ngIf="isLoading">
  <gpu-loading-spinner></gpu-loading-spinner>
</gpu-loading-spinner-wrapper>
